import { BehaviorSubject } from 'rxjs';
import { inject } from '../utils';

class StateInstance {
  constructor(globalCache, sessionCache) {
    this.globalCache = globalCache;
    this.sessionCache = sessionCache;
  }

  init(name, defaultState, type) {
    this.subject$ = new BehaviorSubject(defaultState);
    this.name = name;
    this.cacheKey = `StateInstance.${this.name}`;
    this.defaultState = defaultState;
    this.isGlobal = type === 'global';

    this.getCache()
      .getItem(this.cacheKey)
      .then(cachedValue => this.subject$.next(cachedValue || this.defaultState));
  }

  getCache() {
    return this.isGlobal ? this.globalCache : this.sessionCache;
  }

  get value() {
    return this.subject$.getValue();
  }

  save() {
    this.getCache()
      .setItem(this.cacheKey, this.value);
  }

  subscribe(...args) {
    return this.subject$.subscribe(...args);
  }

  update(updater) {
    const currentState = this.value;

    const nextState = (typeof updater === 'function') ?
      updater(currentState, this.defaultState) :
      { ...currentState, ...updater };

    this.subject$.next(nextState);
  }
}

inject(StateInstance, ['GlobalCache', 'SessionCache']);
export default StateInstance;



// WEBPACK FOOTER //
// ./src/services/StateInstance.js